import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/product",

  async get(url = null) {
    const products = await Request.getAsync(url);
    let data = {};
    if (products.data.status) {
      data = products.data.data;
      for (const [key, value] of Object.entries(data)) {
        data[key].unit_sell_text = Const.product_unit[value.unit_sell];
        data[key].unit_buy_text = Const.product_unit[value.unit_buy];
      }
    } else {
      data = products.data;
    }
    return data;
  },
  async post(url = null, data = null) {
    const products = await Request.postAsync(url, data);
    // let returnData = {};
    // if (products.data.status) {
    //   returnData = products.data.data;
    // }else{
    //   returnData = products.data;
    // }
    return products.data;
  },

  async get_product(proId = null) {
    if (proId == null) {
      throw new Error("Product ID not found.");
    }
    const url = this.BaseURL + "/" + proId;
    const data = await this.get(url);
    return data[0];
  },

  async get_all_product(supId = null) {
    const url = (supId != null) ? this.BaseURL + "/supplier/" + supId : this.BaseURL;
    return await this.get(url);
  },

  async get_supplier_product(supId = null) {
    if (supId == null) {
      throw new Error("Supplier ID not found.");
    }
    return await this.get_all_product(supId);
  },

  async update_inventory(products){
    const url = this.BaseURL + "/update_inventory";
    return await this.post(url, products);
  }



};



// WEBPACK FOOTER //
// ./src/model/product_model.js